module.exports = __webpack_public_path__ + "static/media/clipboard.2af44e06.svg";